import { AddFundsFooterButtons } from '@tcs/fund-account/components/molecules/AddFundsFooterButtons';
import { DepositModel, PaymentType } from '@tcs/fund-account/models/Deposit';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';

export const FundAccountDepositForm: React.FC = () => {
  // Implement state and event handlers as needed
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [depositAmount, setDepositAmount] = useState(0);
  const nav = useNavigate();
  const [hide, setIsHidden] = useState(true);
  const onSelectPaymentMethod = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedPaymentMethod(event.target.value);
  };

  const onCancelClicked = () => {
    nav('/funding');
  };

  const onSubmitDepositClicked = () => {
    const deposit: DepositModel = {
      amount: depositAmount,
      paymentType: selectedPaymentMethod as PaymentType,
    };

    nav('/funding/next-steps');
  };

  return (
    <div>
      {hide ? null : (
        <div>
          <form
            className="iras-a-fund-account-deposit-form"
            name="vm.depositForm">
            <div className="iras-a-module-wrapper">
              <div className="iras-a-fieldset-panel">
                <div className="iras-a-fieldset-panel__header clearfix">
                  <h3 className="iras-a-fieldset-panel__header-title">
                    Fund your account with a cash contribution
                  </h3>
                </div>
                <div className="iras-a-fieldset-panel__content iras-a-fieldset-panel__content--no-footer clearfix">
                  <p>
                    It&apos;s easy to get started. You can fund your account
                    with a cash contribution by check or ACH.
                  </p>
                  <p>
                    <b>
                      To make a cash contribution you&apos;ll need the following
                      information:
                    </b>
                  </p>
                  <ul className="iras-a-text-list">
                    <li className="iras-a-text-list__item">
                      The amount you would like to contribute
                    </li>
                    <li className="iras-a-text-list__item">
                      The payment method you wish to use
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Account to transfer from Component (convert ng-include to React component) */}
            <div className="iras-a-module-wrapper">
              <div className="iras-a-fieldset-panel">
                <div className="iras-a-fieldset-panel__header clearfix">
                  <h3 className="iras-a-fieldset-panel__header-title">
                    Contribution
                  </h3>
                </div>
                <div className="iras-a-fieldset-panel__content iras-a-fieldset-panel__content--no-footer clearfix">
                  <div className="iras-a-fund-account-deposit-form__row">
                    <div className="iras-a-fund-account-deposit-form__field-group">
                      {/* Deposit amount */}
                      <div className="iras-a-fund-account-deposit-form__field--deposit-amount">
                        <label
                          className="iras-a-fund-account-deposit-form__label--deposit-amount"
                          htmlFor="depMount">
                          Amount ($)
                        </label>
                        <input
                          data-private
                          type="number"
                          id="depMount"
                          name="depMount"
                          className="iras-a-fund-account-deposit-form__input--deposit-amount"
                          value={depositAmount}
                          onChange={(event) => {
                            setDepositAmount(
                              Number.parseFloat(event.target.value)
                            );
                          }}
                          onFocus={() => {
                            // Implement onFocus event handling
                          }}
                        />
                      </div>
                      {/* /Deposit amount */}

                      {/* Payment method */}
                      <div className="iras-a-fund-account-deposit-form__field--payment-method">
                        <label
                          className="iras-a-fund-account-deposit-form__label--payment-method"
                          htmlFor="acType">
                          Payment method
                        </label>
                        <label className="iras-a-fund-account-deposit-form__select--payment-method">
                          <select
                            id="paymentMethod"
                            name="paymentMethod"
                            className="iras-a-fund-account-deposit-form__input--payment-method"
                            value={selectedPaymentMethod}
                            onChange={onSelectPaymentMethod}
                            onFocus={() => {
                              // Implement onFocus event handling
                            }}>
                            <option value="">-Select-</option>
                            <option key={'ACH'} value={'ACH'}>
                              ACH
                            </option>
                            <option key={'Cash'} value={'Cash'}>
                              Cash
                            </option>
                          </select>
                        </label>
                      </div>
                      {/* /Payment method */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Account to transfer from */}
            {/* Add Funds Footer Buttons Component (convert ng-include to React component) */}
            <AddFundsFooterButtons
              onCancelClicked={onCancelClicked}
              onSubmitClicked={onSubmitDepositClicked}
            />
          </form>
        </div>
      )}
    </div>
  );
};

export default FundAccountDepositForm;
